export default __webpack_public_path__ + "static/media/pizza-holder.53c20ffd.jpg";